export default {
  userList:{},
  userValuePairs:[],
  userData: {},
  userCount: 0
};



// WEBPACK FOOTER //
// ./src/store/modules/membership/state.js